export const annaWroblewskaCzerniak = {
    'mydrId': 'annawróblewska-czerniak',
    'firstName': 'Anna',
    'lastName': 'Wróblewska-Czerniak',
    'profession': 'Psychoterapeuta osób dorosłych, psycholog, socjoterapeuta',
    'avatar': 'anna-wroblewska-czerniak.webp',
    'slug': 'psycholog-psychoterapeuta-anna-wroblewska-czerniak',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychology', 'consultation'],
    ]
}